import { HttpEventType } from '@angular/common/http';
import { Component, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { BreakdownImportModel } from 'src/app/models/imports/breakdown-import';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { BreakdownModel } from 'src/app/models/preliminaries/breakdown-model';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { BreakdownService } from 'src/app/services/preliminaries/breakdown.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-breakdown',
  templateUrl: './import-breakdown.component.html',
  styleUrls: ['./import-breakdown.component.scss'],
  standalone: false
})
export class ImportBreakdownComponent implements OnInit {
  breakdownsInSolution: boolean = false;
  errorBreakdown: number = 0;
  quotationSolutionContract: QuotationDetailModel = new QuotationDetailModel();
  suscription: Subscription;
  rows: BreakdownModel[] = [];
  eventFile: any;
  nameFile: string = '';
  visibleTxt: boolean = false;
  breakdownAlerts: PreInvoicingAlertModel[] = [];

  constructor(private breakdownService: BreakdownService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef
  ) {
  }

  ngOnInit(): void {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.quotationSolutionContract = inputs.quotationSolutionModel;
      this.breakdownsInSolution = inputs.breakdownsInSolution;
    });
  }

  attachFileImport() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadErrorsTxt() {
    if (!this.breakdownAlerts || this.breakdownAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar.');
      return;
    }

    this.breakdownService.exportImportErrors(this.breakdownAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];
        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionDespieces_${formatDate}.txt`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.breakdownService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaDespieceCotización.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });

  }

  importQuotations() {
    this.breakdownAlerts = [];
    this.errorBreakdown = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<BreakdownImportModel>();
    let row: BreakdownImportModel;
    let counter: number = 1, consecutiveQuotation: number, articleCode: number, articleName: string, quantity: number, unitValue: number, discountRate: number;

    if (input.files[0]) {
      readXlsxFile(input.files[0]).then(async (rows) => {
        if (rows.length <= 1) {
          this.toastHandlerService.showToast('error', 'El archivo ingresado no tiene registros para importar.', '');
          return;
        }
        rows.splice(0, 1);
        rows.forEach(element => {
          counter = counter + 1;
          let rowHasError = false;

          //A. Consecutivo solución:
          const valueQuotationConsecutive = element[0];
          if (valueQuotationConsecutive == null || valueQuotationConsecutive === "") {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. El consecutivo de la solución no es válido.`;
            this.breakdownAlerts.push(alert);
            rowHasError = true;
          }
          consecutiveQuotation = Number(valueQuotationConsecutive);
          if (isNaN(consecutiveQuotation)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. El consecutivo de la solución no es válido.`;
            this.breakdownAlerts.push(alert);
            rowHasError = true;
          }

          //B. Código Artículo:
          const valueArticleCode = element[1];
          if (valueArticleCode == null || valueArticleCode === "") {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
            this.breakdownAlerts.push(alert);
            rowHasError = true;
          }
          articleCode = Number(valueArticleCode);
          if (isNaN(articleCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
            this.breakdownAlerts.push(alert);
            rowHasError = true;
          }

          //C. Nombre Artículo:
          articleName = element[2] as string;
          if (articleName != null) {
            if (articleName.length > 200) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El nombre del artículo: supera el tamaño máximo de caracteres (200).`;
              this.breakdownAlerts.push(alert);
              rowHasError = true;
            }
          }

          //D. Cantidad
          const valueQuantity = element[3];
          if (valueQuantity == null || valueQuantity === "") {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. La cantidad no es válida.`;
            this.breakdownAlerts.push(alert);
            rowHasError = true;
          }
          quantity = Number(valueQuantity);
          if (isNaN(quantity)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. La cantidad no es válida.`;
            this.breakdownAlerts.push(alert);
            rowHasError = true;
          }

          //E. Valor Artículo:
          const valueInitialValue = element[4];
          if (valueInitialValue == null || valueInitialValue === "") {
            unitValue = 0; // Asignamos 0 por defecto
          } else {
            unitValue = Number(valueInitialValue);
            if (isNaN(unitValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna E. El valor no es válido.`;
              this.breakdownAlerts.push(alert);
              rowHasError = true;
            }
          }

          //F. Descuento:
          const valuediscountRate = element[5];
          if (valuediscountRate == null || valuediscountRate === "") {
            discountRate = 0; // Asignamos 0 por defecto
          } else {
            discountRate = Number(valuediscountRate);
            if (isNaN(discountRate)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna F. El valor des descuento no es válido.`;
              this.breakdownAlerts.push(alert);
              rowHasError = true;
            }
          }

          if (!rowHasError) {
            row = new BreakdownImportModel(counter, this.quotationSolutionContract.quotationDetailId,
              consecutiveQuotation, articleCode, articleName, quantity, unitValue, discountRate);
            rowsImports.push(row);
          } else {
            isOk = false;
          }
        });

        if (isOk && rowsImports.length > 0) {
          try {
            const response = await firstValueFrom(this.breakdownService.importBreakdownAsync(rowsImports));
            this.breakdownAlerts = response?.alerts ?? [];
            this.errorBreakdown = response?.preInvoicingStateId;

            if (this.errorBreakdown === 1) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast(
                'error',
                'La importación terminó con errores, puede exportarlos si lo desea.',
                'ERROR'
              );
            } else if (this.breakdownAlerts.length > 0) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast(
                'error',
                'La importación terminó con alertas, puede exportarlas si lo desea'
              );
            } else {
              if (response) {
                this.visibleTxt = false;
                const output$ = this.config.data?.output$;
                output$?.next({ type: 'updateList', payload: true });
                this.toastHandlerService.showToast('success', 'La importación terminó exitosamente.', '');
              }
              if (this.ref) this.ref.close();
            }

          } catch (error) {
            this.nameFile = 'Ningún archivo seleccionado.';
            console.error('Error en la importación de despiece de cotizaciones.', error);
          }
          (<HTMLInputElement>document.getElementById('fileImport')).value = '';
        } else {
          this.errorBreakdown = 1;
          this.visibleTxt = true;
          this.toastHandlerService.showToast(
            'error',
            'La importación terminó con errores, puede exportarlos si lo desea'
          );
        }
      });
    } else {
      this.toastHandlerService.showToast('error', 'No ha seleccionado ningún archivo.', '');
    }
  }

}

